import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Button, TextField, Checkbox, Snackbar, Alert  } from '@mui/material';
import axios from 'axios'
import { TbLoader } from 'react-icons/tb';

const useStyles = makeStyles((theme)=>({
  main: {
    
  },
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',
  },
  h1SearchDiv:{
    padding:'40px 0px 20px 0',
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  boardConfigBlockH1:{
    fontWeight:'700',
    fontSize:'22px',
  },
  datagridBox: {
    wordBreak:'break-all',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'scroll',
    overflowY: 'hidden',
    border: '1px solid #D3D3D3',
  },
  datagridTop: {
    display: 'flex',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop:'none',
    borderBottom:'none',
    padding:'5px 0',

    [theme.breakpoints.down(557)]: {
      fontSize:'11px'
    },
  },
  contBox: {
    display: 'flex',
    alignItems: 'center',
  },
  contBoxItem: {
    textAlign:'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [theme.breakpoints.down(557)]: {
      fontSize:'10px'
    },
  },
  textLeft: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
  },
  textRight: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textMiddle: {
    width: '100%', 
    height: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  checkBoxMain:{
  },
  topBtnDiv:{
    display:'flex',
    justifyContent:'end',
  },
  bottomBtnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px',
  },
  middleBtnButton:{
    margin:'0 40px',

    [theme.breakpoints.down(400)]: {
      margin:'0',           
    }
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
}));

const BoardGroupConfig = () => {
  const checkBox = true
  const theme = useTheme();
  const classes = useStyles(theme);
  const [checks, setChecks] = useState([])
  const [allChecked, setAllChecked] = useState(false)
  const row = [
    {name: '그룹아이디', width: '33.3%'},
    {name: '제목', width: '33.3%'},
    {name: '게시판', width: '33.3%'},
  ];
  const [data, setData] = useState([])

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [loading, setLoading] = useState(false)


  const getBoardGroupItems = async() => {
    try {
      setLoading(true)
      const res = await axios.get('/api/adm/boardGroup/')

      if(res.data.success === false) {
        setLoading(false)
        setErrSnack(true)
        return ;
      }

      setData(res.data.result.reduce((result, item, idx) => [
        ...result, 
        [{id: item['gr_id'], data: item['gr_id'], type: 'textMiddle'},
        {id: item['gr_id'], data: item['gr_subject'], type: 'textfield'},
        {id: item['gr_id'], data: res.data.boardCount[idx], type: 'textMiddle'},
        ]
      ], []))
      setLoading(false)
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getBoardGroupItems()

    return () => {
      setData([])
    }
  }, [])

  useEffect(() => {
    // 전체선택 관련 로직
    let allCheckList = []

    if(allChecked) {
      data.forEach(item => allCheckList.push(item[0].id));
      setChecks(allCheckList)
    } else {
      setChecks(allCheckList)
    }
    
  }, [allChecked])


  const editSelItems = async() => {
    let grList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem[0].id === arrItem){
          grList.push({gr_id: dataItem[0].data, gr_subject: dataItem[1].data})
        } 
      })
    })

    try {
      const res = await axios.post('/api/adm/boardGroupSelectEdit/', {gr_id: grList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setSuccSnack(true)
      getBoardGroupItems()
    
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const delSelItems = async() => {
    let grList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem[0].id === arrItem){
          grList.push({gr_id: dataItem[0].data})
        } 
      })
    })

    try {
      const res = await axios.post('/api/adm/boardGroupSelectDelete/', {gr_id: grList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }
      setSuccSnack(true)
      getBoardGroupItems()
      
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }


  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.boardGroupConfigBlock}>
      
      <div className={classes.box}>
        <div className={classes.h1SearchDiv}>
          <h1 className={classes.boardConfigBlockH1}>
            게시판그룹관리
          </h1>
          <div className={classes.topBtnDiv}>
          <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>
            선택수정
          </Button>
        </div>
      </div>         
        <div className={classes.datagridBox}>
          <div className={classes.datagridTop}>
            {checkBox && (
                <div className={classes.checkBoxMain}>
                  <Checkbox 
                    checked={allChecked}
                    onChange={e => setAllChecked(e.target.checked)}
                  />
                </div>
            )}
  
            {row.map((item, index) => (
                      <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                        {item.name}
                      </div>
            ))}
          </div>
  
          {loading ? (
            <div className={classes.load}>
              <TbLoader className={classes.loadingIcon}/>
            </div>
          ) :
          data.length > 0 && data.map((dataItem, dataIndex) => {
            return(
                    <div 
                      key={dataIndex} 
                      className={classes.contBox}
                      style={{
                        backgroundColor: dataIndex % 2 == 0 && '#F2F2F2'
                      }}
                    >
                        {checkBox && (
                          <div className={classes.checkBoxMain}>
                            <Checkbox
                              checked={checks.includes(dataItem[0].id)}
                              onChange={() => !checks.includes(dataItem[0].id) ?
                                              setChecks([...checks, dataItem[0].id]) : 
                                              setChecks([...checks.filter((item) => item !==  dataItem[0].id)])
                                        }
                            />
                          </div>
                        )}
  
                        {dataItem.map((item, index) => {
                          return(
                                <div key={index} className={classes.contBoxItem} style={{width: row[index].width}}>
                                  {item.type === 'textLeft' && (
                                    <h3 className={classes.textLeft}>{item.data}</h3>
                                  )}
                                  {item.type === 'textRight' && (
                                    <h3 className={classes.textRight}>{item.data}</h3>
                                  )}
                                  {item.type === 'textMiddle' && (
                                    <h3 className={classes.textMiddle}>{item.data}</h3>
                                  )}
                                  {item.type === 'textfield' && (
                                    <TextField
                                      hiddenLabel
                                      id="filled-hidden-label-small"
                                      value={item.data}
                                      variant="outlined"
                                      size="small"
                                      sx={{ m:1.5 }}
                                      fullWidth
                                      onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: e.target.value}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)}
                                        }
                                    />
                                  )}                    
  
                                </div>
                        )})}
                    </div>
          )})}  
        </div>
      </div>



      <div className={classes.bottomBtnDiv}>
        <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>
          선택수정
        </Button>
        {/* <div className={classes.middleBtnButton}>
          <Button variant="outlined" onClick={() => checks.length > 0 && delSelItems()}>
            선택삭제
          </Button> 
        </div>                               
        <Button variant="outlined">
          게시판 그룹 추가
        </Button>         */}
      </div>                          



      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar>   


    </div>
  )
}

export default BoardGroupConfig
